import { render } from "./OddIcon.vue?vue&type=template&id=79f3e371&scoped=true"
import script from "./OddIcon.vue?vue&type=script&lang=js"
export * from "./OddIcon.vue?vue&type=script&lang=js"

import "./OddIcon.vue?vue&type=style&index=0&id=79f3e371&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79f3e371"]])

export default __exports__